var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import styled from "styled-components";
import { Flex } from "../Flex";
export var ListOrientation;
(function (ListOrientation) {
    ListOrientation[ListOrientation["VERTICAL"] = 0] = "VERTICAL";
    ListOrientation[ListOrientation["HORIZONTAL"] = 1] = "HORIZONTAL";
})(ListOrientation || (ListOrientation = {}));
const StyledList = styled(Flex)(({ orientation, maxHeight, theme: { borders, radii, colors: { listColors }, }, }) => ({
    background: listColors.background,
    border: borders[1],
    borderColor: listColors.border,
    borderRadius: radii[1],
    display: "flex",
    flexDirection: orientation === ListOrientation.VERTICAL ? "column" : "row",
    margin: 0,
    maxHeight,
    overflow: "hidden",
    overflowY: maxHeight ? "auto" : "inherit",
    padding: 0,
}));
export const List = forwardRef((_a, ref) => {
    var { children, onItemSelect, orientation = ListOrientation.VERTICAL } = _a, props = __rest(_a, ["children", "onItemSelect", "orientation"]);
    return (React.createElement(StyledList, Object.assign({ ref: ref, as: "ul", orientation: orientation }, props), React.Children.map(children, (child, pos) => {
        const { props: { onClick: oldOnClick, index = pos }, } = child;
        return React.cloneElement(child, {
            onClick: onItemSelect !== undefined
                ? (e) => {
                    if (oldOnClick)
                        oldOnClick(e);
                    onItemSelect(index);
                }
                : oldOnClick,
        });
    })));
});
